import React from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { connect } from "react-redux";
import CloseIcon from "../Layout/Icons/CloseIcon";
import Logo from "./Logo";
import SocialIcons from "./SocialIcons";
import CopyUrl from "./CopyUrl";
import "./Share.css";

class Share extends React.Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown = (event) => {
    const ESCAPE_KEY = 27;
    if (event.keyCode === ESCAPE_KEY) {
      this.props.handleCloseShare();
    }
  };

  handleClick = () => {
    this.props.handleCloseShare();
  };

  render() {
    const shareImageUrl = `${process.env.REACT_APP_TEXT_EFFECTS_URL}design/${this.props.design.id}.png`,
      baseUrl = process.env.REACT_APP_CUSTOMIZER_ROOT,
      url = `${baseUrl.replace(/\/+$/, '')}/${this.props.design.id}/customize/`,
      fbUrl = `${process.env.REACT_APP_API_ROOT}design/${this.props.design.id}/`;

    return (
      <CSSTransitionGroup
        transitionName="share"
        transitionAppear={true}
        transitionAppearTimeout={50}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div
          className={`share-dialog ${this.props.shareClosing ? "closing" : "open"}`}
          key="1"
        >
          <div className="share-dialog__container">
            <div className="button--close-share" onClick={this.handleClick}>
              <CloseIcon />
            </div>

            <Logo />

            <div className="share-dialog__content">
              <h3>Share Your Design</h3>

              {this.props.design.id && (
                <SocialIcons
                  title={this.props.design.name}
                  shareImageUrl={shareImageUrl}
                  url={url}
                  fbUrl={fbUrl}
                />
              )}

              <CopyUrl url={url} />
            </div>
          </div>
        </div>
      </CSSTransitionGroup>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present
  };
}

export default connect(mapStateToProps)(Share);
